// 9fbef606107a605d69c0edbcd8029e5d
/**
 * These are temporary changes for a dummy login page
 */

const FORGOTPASSWORD_CONSTANTS = {
  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  USER_NOT_AVAILABLE: 'USER_NOT_AVAILABLE',
  RESET_PASSWORD_FAIL: 'RESET_PASSWORD_FAIL',
  RESET_PASSWORD_LOGIN_STATE: 'RESET_PASSWORD_LOGIN_STATE',
  RESET_PASSWORD_SUCCESSFULL_EMAIL: 'RESET_PASSWORD_SUCCESSFULL_EMAIL',
  RESET_PASSWORD_SUCCESSFULL: 'RESET_PASSWORD_SUCCESSFULL',
  FORGOT_PASSWORD_FORM: 'forgotPasswordForm',
  FORGOT_PASSWORD_SUBMIT_START: 'FORGOT_PASSWORD_SUBMIT_START',
  FORGOT_PASSWORD_SUBMIT_STOP: 'FORGOT_PASSWORD_SUBMIT_STOP',
  FORGOT_PASSWORD_SET_LOGON_ID: 'FORGOT_PASSWORD_SET_LOGON_ID',
  FORGOT_PASSWORD_SCREEN_FROM_LOGIN: 'FORGOT_PASSWORD_SCREEN_FROM_LOGIN',
  PASS_RESET_OPTION_SELECTOR: 'PASS_RESET_OPTION_SELECTOR',
  SHOW_PHONE_RESET_OPTION: 'SHOW_PHONE_RESET_OPTION',
  SHOW_OTP_SCREEN: 'SHOW_OTP_SCREEN',
  MASKED_PHONE_NUMBER: 'MASKED_PHONE_NUMBER',
  SEND_OTP_ERROR: 'SEND_OTP_ERROR',
  USER_EMAILADDRESS: 'USER_EMAILADDRESS',
  GET_MODULEX_CONTENT: 'GET_MODULEX_CONTENT',
  SET_MODULEX_CONTENT: 'SET_MODULEX_CONTENT',
  SET_RESETPASS_EMAIL: 'SET_RESETPASS_EMAIL'
};

export default FORGOTPASSWORD_CONSTANTS;
